<template>
  <div>
      <v-tooltip bottom>
          <v-btn slot="activator"
                  :disabled="!nota.item.pathIPTU" :class="[!nota.item.pathIPTU ? 'c_disabled' : '']"
                  icon
                  small
                  flat
                  @click="getPdfById(nota.item._id,nota.item.pathIPTU) "
                  >
                  <v-icon class="material-icons">remove_red_eye</v-icon>
              </v-btn>
              <span> {{nota.item.pathIPTU ?'Visualizar PDF' : 'PDF não disponível.'}}</span>
       </v-tooltip>
                  <v-dialog @keydown.esc="dialog = false"
                  v-model="dialog"

                  fullscreen
                  :lazy="true"
                  >
                      <v-card>
                          <v-card-title
                          class="headline darkBlue text-xs-center"
                          text-color="white"
                          style="color: white;"

                          >
                          IPTU
                          <v-spacer></v-spacer>
                          <v-btn icon dark @click.native="dialog = false">
                              <v-icon>close</v-icon>
                          </v-btn>
                          </v-card-title>

                          <v-card-text id="tst">
                              <iframe style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe)" frameborder="0"/>

                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="primary"
                              flat
                              @click="dialog = false"
                          >
                              Fechar
                          </v-btn>
                          </v-card-actions>
                      </v-card>
                  </v-dialog>
  </div>

</template>
<script>
import IptuService from "@/domain/automacaoFiscal/iptu/IptuService"
export default {
props: ["nota"],
data() {
  return {
    dialog: false
  };
},
watch: {},
computed: {},
methods: {
  getPdfById: async function(id,pathIPTU) {
    if (!this.nota.item.danfe) {
      this.service = new IptuService(this.$http);
      await this.service
        .getPdfById(id,pathIPTU)
        .then(danfe => (this.nota.item.danfe = danfe));
    }

    if (this.nota.item.danfe != null) {
      this.dialog = true;
    }
  }
}
};
</script>
<style>

#lista {
padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnVisualizar/btnIptu/BtnIptu.vue